import { ActionConfirmDialog } from './action-confirm-dialog.component';

export type DeleteConfirmDialogProps = {
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  message: string;
};

export const DeleteConfirmDialog = ({
  onClose,
  onConfirm,
  loading,
  message,
}: DeleteConfirmDialogProps) => {
  return (
    <ActionConfirmDialog
      onClose={onClose}
      onConfirm={onConfirm}
      message={message}
      confirmButtonColor='error'
      confirmButtonDisabled={loading}
    />
  );
};
